/* ============================================================
   Yummii Yummii - sporing af alt omkring GoWish / Ønskeskyen

   Hvad der maales:
   1. Klik paa "Tilføj til Ønskeskyen/GoWish" paa produktsiden
      - Meta AddToWishlist (pixel + meta-capi, samme event_id -> dedup)
      - GA4 add_to_wishlist (med produkt, pris og valuta)
      - Klaviyo "Added to GoWish" (kan bruges i flows/segmenter)
      - dataLayer yy_gowish (til GTM/Stape)
   2. GoWish-vinduet: hvor laenge det var aabent (GA4 gowish_dialog_closed)
   3. Forsidens GoWish-teaser og kollektionens hero: view_promotion
      (naar halvdelen er synlig) og select_promotion (klik)
   4. Klik paa produktkort med "Mest ønsket"-badget
   5. Klik paa gavekortet i GoWish-infoboksen
   6. Besoeg der kommer FRA GoWish (referrer/utm): GA4 gowish_visit og
      kurv-attributten "Kilde: GoWish", saa ordren kan genkendes i Shopify

   Hvad der IKKE kan maales: om kunden faktisk gemmer oensket. GoWish'
   vindue er en iframe paa deres domaene, og deres script sender ingen
   "gemt"-besked tilbage - kun aabn/luk. Klikket er derfor det taetteste
   vi kommer paa en tilfoejelse.

   Samtykke: Meta, meta-capi og Klaviyo kraever marketingsamtykke,
   GA4/dataLayer kraever statistiksamtykke (Shopify.customerPrivacy).
   Sporing maa aldrig staa i vejen for knappen: alt er pakket i try.
   ============================================================ */
(function () {
  'use strict';
  if (window.__yyGowish) return;
  window.__yyGowish = true;

  var CAPI = 'https://yurkyuiflxssoxgzocai.supabase.co/functions/v1/meta-capi';
  var GA4 = 'G-900BBZY5B1';
  var PROMO = { promotion_id: 'gowish-julegaver-2026', promotion_name: 'GoWish julegaver' };

  /* ---------- samtykke ---------- */
  function cp() { return window.Shopify && window.Shopify.customerPrivacy; }
  function marketing() {
    try { var c = cp(); if (c && c.marketingAllowed) return !!c.marketingAllowed(); } catch (e) {}
    return typeof window.fbq === 'function';
  }
  function statistik() {
    try { var c = cp(); if (c && c.analyticsProcessingAllowed) return !!c.analyticsProcessingAllowed(); } catch (e) {}
    return true;
  }

  /* ---------- hjaelpere (samme moenster som yy-tidlig-adgang.js) ---------- */
  function cookie(n) {
    try { var m = document.cookie.match('(^|;)\\s*' + n + '\\s*=\\s*([^;]+)'); return m ? decodeURIComponent(m[2]) : ''; }
    catch (e) { return ''; }
  }
  function fbc() {
    var c = cookie('_fbc'); if (c) return c;
    try { var id = new URLSearchParams(location.search).get('fbclid'); return id ? 'fb.1.' + Date.now() + '.' + id : ''; }
    catch (e) { return ''; }
  }
  function sha256(s) {
    try {
      return crypto.subtle.digest('SHA-256', new TextEncoder().encode(String(s).trim().toLowerCase()))
        .then(function (h) { return Array.from(new Uint8Array(h)).map(function (x) { return x.toString(16).padStart(2, '0'); }).join(''); })
        .catch(function () { return ''; });
    } catch (e) { return Promise.resolve(''); }
  }
  function uuid() {
    try { if (crypto.randomUUID) return crypto.randomUUID(); } catch (e) {}
    return 'gw-' + Date.now() + '-' + Math.random().toString(16).slice(2, 10);
  }
  /* Besoegende-id: samme cookie som oenskeliste-pop-uppen og quizzen.
     Den findes kun i DK i forvejen, saa vi opretter den her, naar der er
     marketingsamtykke - ellers faar /de-klik ingen external_id. */
  function besoegende() {
    var v = cookie('yy_vid');
    if (v || !marketing()) return v;
    try {
      v = uuid();
      document.cookie = 'yy_vid=' + encodeURIComponent(v)
        + ';path=/;max-age=63072000;samesite=lax' + (location.protocol === 'https:' ? ';secure' : '');
    } catch (e) { v = ''; }
    return v;
  }

  function ga(navn, data) {
    if (!statistik()) return;
    try {
      var args = ['event', navn, Object.assign({ send_to: GA4 }, data)];
      if (typeof window.gtag === 'function') window.gtag.apply(window, args);
      /* gtag findes ikke endnu ved sideindlaesning (fx gowish_visit): saa
         i koeen paa samme maade som Googles egen stub - gtag.js laeser den. */
      else (function () { (window.dataLayer = window.dataLayer || []).push(arguments); }).apply(window, args);
    } catch (e) {}
  }
  function dl(data) {
    if (!statistik()) return;
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'yy_gowish' }, data)); } catch (e) {}
  }
  function klaviyo(navn, data) {
    if (!marketing()) return;
    try {
      if (window.klaviyo && typeof window.klaviyo.track === 'function') window.klaviyo.track(navn, data);
      else (window._learnq = window._learnq || []).push(['track', navn, data]);
    } catch (e) {}
  }
  function hotjar(navn) {
    try { if (typeof window.hj === 'function' && statistik()) window.hj('event', navn); } catch (e) {}
  }

  /* ---------- 1. knappen paa produktsiden ---------- */
  var sidst = {};
  function knapKlik(knap) {
    var d = knap.dataset || {};
    var id = String(d.yyGwId || '');
    if (sidst[id] && Date.now() - sidst[id] < 3000) return;   // dobbeltklik taeller én gang
    sidst[id] = Date.now();

    var navn = d.yyGwNavn || document.title;
    var pris = parseFloat(d.yyGwPris) || 0;
    var valuta = d.yyGwValuta || (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
    var land = (window.Shopify && Shopify.country) || '';
    var tjeneste = /ønskeskyen|onskeskyen/i.test(knap.textContent || '') ? 'onskeskyen' : 'gowish';
    var eventId = uuid();
    /* Meta-kataloget (Shopifys Facebook-kanal) matcher paa VARIANT-id -
       det er ogsaa det, Shopifys egen pixel sender i ViewContent. GA4 og
       Stape bruger derimod produkt-id som item_id. */
    var metaId = String(d.yyGwVariant || id);

    ga('add_to_wishlist', {
      currency: valuta, value: pris, wishlist_service: tjeneste,
      items: [{ item_id: id, item_name: navn, item_variant: d.yyGwVariant || '', item_category: d.yyGwKat || '', item_brand: 'Yummii Yummii', price: pris, quantity: 1 }]
    });
    dl({ gowish_action: 'add_to_wishlist', gowish_service: tjeneste, product_id: id, product_name: navn, value: pris, currency: valuta, event_id: eventId });
    hotjar('gowish_click');

    if (!marketing()) return;
    try {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'AddToWishlist', {
          content_ids: [metaId], content_type: 'product', content_name: navn, value: pris, currency: valuta
        }, { eventID: eventId });
      }
    } catch (e) {}
    klaviyo('Added to GoWish', {
      ProductID: id, ProductName: navn, Price: pris, Currency: valuta, Country: land,
      URL: location.origin + location.pathname, Service: tjeneste, $value: pris
    });
    var vid = besoegende();
    (vid ? sha256(vid) : Promise.resolve('')).then(function (ext) {
      return fetch(CAPI, {
        method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          event_name: 'AddToWishlist', event_id: eventId, external_id: ext,
          fbp: cookie('_fbp'), fbc: fbc(), event_source_url: location.href,
          content_ids: [metaId], value: pris, currency: valuta,
          content_name: navn, content_category: tjeneste
        })
      });
    }).catch(function () {});
  }

  /* ---------- 2. GoWish-vinduet aabent/lukket ---------- */
  var aabnet = 0;
  function overvaagVindue() {
    var dlg = document.getElementById('gowish-iframe-dialog');
    if (!dlg || dlg.__yyGw) return !!dlg;
    dlg.__yyGw = true;
    function tjek() {
      if (dlg.open && !aabnet) {
        aabnet = Date.now();
        ga('gowish_dialog_open', {});
      } else if (!dlg.open && aabnet) {
        var sek = Math.round((Date.now() - aabnet) / 1000);
        aabnet = 0;
        ga('gowish_dialog_closed', { seconds_open: sek });
        dl({ gowish_action: 'dialog_closed', seconds_open: sek });
      }
    }
    new MutationObserver(tjek).observe(dlg, { attributes: true, attributeFilter: ['open'] });
    dlg.addEventListener('close', tjek);
    tjek();
    return true;
  }
  /* Vinduet oprettes foerst af GoWish' script ved klik - vent paa det. */
  function ventPaaVindue() {
    if (overvaagVindue()) return;
    var n = 0;
    var t = setInterval(function () { if (overvaagVindue() || ++n > 40) clearInterval(t); }, 250);
  }

  /* ---------- 3. kampagneflader: teaser og hero ---------- */
  function flade(el) {
    if (el.matches('.yy-oef')) return 'forside';
    if (el.matches('.yy-oe')) return 'kollektion';
    return '';
  }
  function promo(el) { return Object.assign({ creative_name: flade(el), creative_slot: flade(el) }, PROMO); }

  function visninger() {
    var flader = document.querySelectorAll('section.yy-oef, section.yy-oe');
    if (!flader.length) return;
    function vis(el) {
      if (el.__yyGwSet) return;
      el.__yyGwSet = true;
      ga('view_promotion', Object.assign(promo(el), { items: [] }));
    }
    if (!('IntersectionObserver' in window)) { flader.forEach(vis); return; }
    var io = new IntersectionObserver(function (poster) {
      poster.forEach(function (p) { if (p.isIntersecting) { vis(p.target); io.unobserve(p.target); } });
    }, { threshold: 0.5 });
    flader.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 5. besoeg fra GoWish ---------- */
  function indgaaende() {
    var kilde = '';
    try {
      var q = new URLSearchParams(location.search);
      var utm = (q.get('utm_source') || '') + ' ' + (q.get('utm_medium') || '');
      if (/gowish|onskeskyen|ønskeskyen/i.test(utm)) kilde = 'utm';
      else if (document.referrer && /(^|\.)(gowish|onskeskyen|ønskeskyen)\./i.test(new URL(document.referrer).hostname)) kilde = 'referrer';
    } catch (e) {}
    if (!kilde) return;
    try { if (sessionStorage.getItem('yy_gw_ind')) return; sessionStorage.setItem('yy_gw_ind', '1'); } catch (e) {}

    ga('gowish_visit', { gowish_source: kilde, page_path: location.pathname });
    dl({ gowish_action: 'visit', gowish_source: kilde });
    /* Kurv-attributten foelger med paa ordren (Yderligere detaljer), saa
       vi kan taelle salg fra GoWish i Shopify uden at stole paa cookies.
       Kurv-attributter er ikke persondata og kraever ikke samtykke. */
    try {
      var rod = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      if (rod.slice(-1) !== '/') rod += '/';
      fetch(rod + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { Kilde: 'GoWish' } })
      }).catch(function () {});
    } catch (e) {}
  }

  /* ---------- klik (delegeret, i capture-fasen, saa vi ser klikket foer
     GoWish' eget script og foer navigation) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    try {
      var knap = t.closest('#gowishBlueButton');
      if (knap) { knapKlik(knap); ventPaaVindue(); return; }

      var link = t.closest('section.yy-oef a, section.yy-oe a');
      if (link) {
        var sek = link.closest('section.yy-oef, section.yy-oe');
        ga('select_promotion', Object.assign(promo(sek), { link_url: link.getAttribute('href') || '' }));
        dl({ gowish_action: 'select_promotion', creative_slot: flade(sek) });
        return;
      }

      var gave = t.closest('.yy-oei__gave');
      if (gave) {
        ga('gowish_giftcard_click', { link_url: gave.getAttribute('href') || '' });
        dl({ gowish_action: 'giftcard_click' });
        return;
      }

      var kort = t.closest('.product-item');
      if (kort && kort.querySelector('.yy-oe-kortbadge')) {
        var a = t.closest('a');
        if (!a) return;
        var titel = (kort.querySelector('.product-item__title') || {}).textContent || '';
        ga('gowish_badge_click', { item_name: titel.trim().slice(0, 100), link_url: a.getAttribute('href') || '' });
        dl({ gowish_action: 'badge_click', product_name: titel.trim().slice(0, 100) });
      }
    } catch (err) {}
  }, true);

  function start() { visninger(); indgaaende(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
